import { render, staticRenderFns } from "./RewardDialog.vue?vue&type=template&id=7324259e&"
import script from "./RewardDialog.vue?vue&type=script&lang=js&"
export * from "./RewardDialog.vue?vue&type=script&lang=js&"
import style0 from "./RewardDialog.vue?vue&type=style&index=0&id=7324259e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports